// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__13MzB","name":"Header_name__2JojU","birthday":"Header_birthday__2SSH_","skeleton":"Header_skeleton__3pPvL"};